<div class="lm__pageHeader">
	<div>
		<h1>Unmatched</h1>
		<p>Logs that do not match any configured active pattern (duplicates grouped by exact message).</p>
	</div>
</div>

<article class="lm__card">
	<div class="lm__cardHeader">
		<h2>Filters</h2>
	</div>

	<div class="lm__cardBody">
		<div class="lm__formGrid">
			<label class="lm__label">
				<span class="lm__labelTitle">Date range</span>
				<select class="lm__input" [(ngModel)]="datePreset">
					<option *ngFor="let preset of datePresetOptions" [ngValue]="preset.value">
						{{ preset.label }}
					</option>
				</select>
			</label>

			<label class="lm__label">
				<span class="lm__labelTitle">Job Log Type</span>
				<select class="lm__input" [(ngModel)]="jobLogType">
					<option *ngFor="let t of jobLogTypeOptions" [ngValue]="t.value">
						{{ t.label }}
					</option>
				</select>
			</label>

			<label class="lm__label">
				<span class="lm__labelTitle">From application</span>
				<select class="lm__input" [(ngModel)]="fromApplicationId">
					<option [ngValue]="null">All</option>
					<option *ngFor="let a of (applications$ | async) ?? []" [ngValue]="a.id">
						{{ a.displayName || a.name }}
					</option>
				</select>
			</label>

			<label class="lm__label">
				<span class="lm__labelTitle">To application</span>
				<select class="lm__input" [(ngModel)]="toApplicationId">
					<option [ngValue]="null">All</option>
					<option *ngFor="let a of (applications$ | async) ?? []" [ngValue]="a.id">
						{{ a.displayName || a.name }}
					</option>
				</select>
			</label>

			<label class="lm__label">
				<span class="lm__labelTitle">Take</span>
				<input class="lm__input" type="number" [(ngModel)]="take" />
			</label>

			<label class="lm__label lm__label--wide" *ngIf="isCustomDateRange">
				<span class="lm__labelTitle">From date</span>
				<input class="lm__input" type="date" [(ngModel)]="fromDate" />
			</label>

			<label class="lm__label lm__label--wide" *ngIf="isCustomDateRange">
				<span class="lm__labelTitle">To date</span>
				<input class="lm__input" type="date" [(ngModel)]="toDate" />
			</label>

			<label class="lm__label lm__label--full">
				<span class="lm__labelTitle">Message pattern</span>
				<input class="lm__input" type="text" [(ngModel)]="messagePattern" placeholder="Example: Invoice failed for customer <VAR>" />
				<span class="lm__hint">Use exact text plus <code>&lt;VAR&gt;</code> for changing parts.</span>
			</label>

			<div class="lm__headerActions">
				<button class="lm__btn" type="button" (click)="search()" [disabled]="loading$ | async">
					{{ (loading$ | async) ? 'Loading…' : 'Search' }}
				</button>
				<button class="lm__btn" type="button" (click)="clear()" [disabled]="loading$ | async">
					Clear
				</button>
			</div>
		</div>

		<div class="lm__error" *ngIf="(error$ | async) as err">
			<span *ngIf="err">{{ err }}</span>
		</div>

		<div class="lm__muted" *ngIf="(copied$ | async) as msg" style="margin-top: 8px;">
			<span *ngIf="msg">{{ msg }}</span>
		</div>
	</div>
</article>

<ng-container *ngIf="groups$ | async as groups">
	<article class="lm__card" style="margin-top: 16px;">
		<div class="lm__cardHeader lm__cardHeader--row">
			<div>
				<h2>Groups</h2>
				<div class="lm__muted">Groups ({{ groups.length }})</div>
			</div>

			<div class="lm__cardHeaderActions">
				<button class="lm__btn" type="button" (click)="exportCsv(groups)" [disabled]="(loading$ | async) || !groups.length">
					Export CSV
				</button>
			</div>
		</div>

		<div class="lm__cardBody">
			<div class="lm__empty" *ngIf="groups.length === 0 && !(loading$ | async)">
				No unmatched logs found in this slice.
			</div>

			<div class="lm__results" *ngIf="groups.length > 0">
				<div class="lm__results" *ngIf="groups.length > 0">
					<div class="lm__results" *ngIf="groups.length > 0">
						<div class="lm__result lm__result--clickable" *ngFor="let g of groups; trackBy: trackByMessage" role="button" tabindex="0" (click)="goAnalysisFromUnmatched(g)" (keydown)="onGroupKeydown($event, g)">

							<div class="lm__resultMeta">
								<span class="lm__pill">x{{ g.count }}</span>
								<span class="lm__muted">{{ g.lastSeenUtc }}</span>

								<span class="lm__spacer"></span>

								<button *ngIf="g.stacktrace" class="lm__btn lm__btn--tiny" type="button" (click)="$event.stopPropagation(); copy(g.stacktrace)">
									Copy Stacktrace
								</button>

								<button class="lm__btn lm__btn--tiny" type="button" (click)="$event.stopPropagation(); copy(g.message)">
									Copy
								</button>

								<button class="lm__btn lm__btn--tiny lm__btn--primaryGhost" type="button" (click)="$event.stopPropagation(); goAnalysisFromUnmatched(g)">
									Analyze
								</button>
							</div>

							<pre class="lm__resultMessage">{{ g.message }}</pre>

							<div class="lm__muted lm__ids" *ngIf="g.jobLogs?.length">
								<span>IDs:</span>
								<ng-container *ngFor="let jobLog of g.jobLogs; trackBy: trackByJobLogId; let last = last">
									<button
										type="button"
										class="lm__idLink"
										(click)="openJobLog(jobLog, $event)"
										(keydown)="onJobLogKeydown($event, jobLog)">
										{{ jobLog.id }}
									</button><span *ngIf="!last">, </span>
								</ng-container>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</article>
</ng-container>
